import { render, staticRenderFns } from "./PatentList.vue?vue&type=template&id=06106d30&"
import script from "./PatentList.vue?vue&type=script&lang=ts&"
export * from "./PatentList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports